import { useState } from "react";
import { useParams } from "react-router";

import { usePortfolioCollection } from "@/lib/hooks/use-portfolio-collections";

import { type PortfolioView, PortfolioViewToggle } from "../portfolio-weights";
import { TableCardSkeleton } from "../skeleton-loaders";
import { PortfoliosGrid } from "./portfolios-grid";
import { PortfoliosTable } from "./portfolios-table";

export default function PortfoliosListPage() {
  const { id } = useParams<{ id: string }>();
  const { collection, isLoading } = usePortfolioCollection(id!);
  const [view, setView] = useState<PortfolioView>("list");

  if (isLoading || !collection) {
    return <TableCardSkeleton columns={6} />;
  }

  return (
    <div>
      <PortfolioViewToggle view={view} onChange={setView} />
      {view === "list" ? (
        <PortfoliosTable collection={collection} />
      ) : (
        <PortfoliosGrid collection={collection} />
      )}
    </div>
  );
}
